import { render, staticRenderFns } from "./ResourceCardGroup.vue?vue&type=template&id=1e618e7e&"
import script from "./ResourceCardGroup.vue?vue&type=script&lang=js&"
export * from "./ResourceCardGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports